@use '../../../../../styles/Constants.scss' as Constants;

.job-tracking-modal {
	&__body {
		overflow: visible;
	}
	
	&__fields {
		display: flex;
		align-items: center;
		gap: Constants.$val-spacing-xxl;
	}

	&__field {
		flex: 1 1 0;
		display: flex;
		align-items: center;
		gap: Constants.$val-spacing-s;

		> span {
			white-space: nowrap;
		}
	}

	&__time-input {
		width: Constants.$val-textFilterMinWidth;
		flex: 0 0 auto;
	}
}